import { render, staticRenderFns } from "./LeaveMutationModal.vue?vue&type=template&id=2eff6890&scoped=true&"
import script from "./LeaveMutationModal.vue?vue&type=script&lang=js&"
export * from "./LeaveMutationModal.vue?vue&type=script&lang=js&"
import style0 from "./LeaveMutationModal.vue?vue&type=style&index=0&id=2eff6890&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eff6890",
  null
  
)

export default component.exports